import React from "react";
import { RaisedButton, Styles } from "material-ui";
import { Navigation } from "react-router";

import PassRuleEditor from "./pass-rule-editor.jsx";
import InfoNotice from "./info-notice.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventActions from "../../actions/EventActions";
import EventStore from "../../stores/EventStore";
import PassBucketActions from "../../actions/PassBucketActions";
import PassBucketStore from "../../stores/PassBucketStore";
import EventBucketStore from "../../stores/EventBucketStore";
import PassRulesEditorNonAtomic from "./pass-rules-editor-nonatomic.jsx";

class PassRulesEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetchingRules: false,
      rules: [],
      orderKey: 0 // Used to force re-rendering of the list
    };

    this.addNew = this.addNew.bind(this);
  }

  static getStores() {
    return [EventStore, PassBucketStore, EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getEventById: EventStore.getEventById,
      getPassBucketById: PassBucketStore.getPassBucketById,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getEventBuckets: EventBucketStore.getEventBuckets
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  onRuleShiftPosition(index, direction) {
    let arr = this.state.rules;
    arr.splice(index + direction, 0, arr.splice(index, 1)[0]);
    this.setState(
      {
        rules: arr,
        orderKey: this.state.orderKey + 1
      },
      function () {
        PassBucketActions.edit(this.props.parentId, {
          rules: this.state.rules
        });
      }
    );
  }

  addNew(item) {
    let isPassBucket = this.props.mode === "pass_bucket";

    this.state.rules.push(item);

    (isPassBucket ? PassBucketActions : EventActions).edit(
      this.props.parentId,
      {
        rules: this.state.rules
      }
    );
  }

  saveRule(index, rule) {
    let isPassBucket = this.props.mode === "pass_bucket";

    if (rule === null) {
      // delete rule
      this.state.rules.splice(index, 1);
    } else {
      this.state.rules[index] = rule;
    }

    PassBucketActions.edit(this.props.parentId, {
      rules: this.state.rules
    });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var isPassBucket = this.props.mode === "pass_bucket";
    var parent = (isPassBucket ? PassBucketStore.getPassBucketById : EventStore.getEventById)(newProps.parentId);
    var rules = parent ? parent.rules || [] : null;

    if (!rules && !this.state.isFetchingRules) {
      (isPassBucket ? PassBucketActions : EventActions).fetchOne(
        newProps.parentId
      );
      this.setState({ isFetchingRules: true, rules: [] });
    } else if (rules) {
      if (
        parent &&
        parent.updated_at &&
        this.state.lastUpdatedAt &&
        parent.updated_at === this.state.lastUpdatedAt
      ) {
        // Ignore update if it's the same as the last one, to avoid flickering
        // of the old rules while a save is in progress.
        return;
      }

      this.setState({
        isFetchingRules: false,
        lastUpdatedAt: parent && parent.updated_at,
        rules: rules
      });
    }
  }

  render() {

    return (
      <PassRulesEditorNonAtomic
        {...this.props}
        passRules={this.state.rules}
        onDelete={i => this.saveRule(i, null)}
        onChange={(i, e) => this.saveRule(i, e)}
        onAdd={e => this.addNew(e)}
        onShiftPosition={(index, direction) =>
          this.onRuleShiftPosition(index, direction)
        }
        orderKey={this.state.orderKey}
        isMembership={this.props.isMembership}
      />
    );
  }
}

export default connectToStores(PassRulesEditor);



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-rules-editor.jsx